import type { AppAbility } from '@/lib/casl'
import { OrganizationType } from '@/lib/enums/OrganizationType'
import type { Organization } from '@/lib/services/organizations/organizations.types'

/** Both checks fail closed while the ability or organization is unavailable. */
type ContractAbility = Pick<AppAbility, 'can'> | null | undefined

export function canCreateContractForOrganization(
  ability: ContractAbility,
  organization: Pick<Organization, 'type'> | null | undefined
): boolean {
  if (!ability || !organization) {
    return false
  }

  return organization.type === OrganizationType.Global.Value
    ? ability.can('create', 'default-contracts')
    : ability.can('create', 'organization-contracts')
}

export function canEditContractMerchantFees(ability: ContractAbility): boolean {
  return Boolean(ability?.can('edit', 'contract-merchant-fees'))
}
